// extracted by mini-css-extract-plugin
module.exports = {"faqsContainer":"Faqs_faqsContainer__2Nl9T","faqsTitle":"Faqs_faqsTitle__2K5qB","faqsQuestion":"Faqs_faqsQuestion__1BcyL","faqsAnswer":"Faqs_faqsAnswer__l5QbA"};